import { render, staticRenderFns } from "./PaymentOptions.vue?vue&type=template&id=5965b7d4&scoped=true"
import script from "./PaymentOptions.vue?vue&type=script&lang=js"
export * from "./PaymentOptions.vue?vue&type=script&lang=js"
import style0 from "./PaymentOptions.vue?vue&type=style&index=0&id=5965b7d4&prod&lang=scss&scoped=true"
import style1 from "./PaymentOptions.vue?vue&type=style&index=1&id=5965b7d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5965b7d4",
  null
  
)

export default component.exports